export enum PeriodSelectorEnum {
  Week = 1,
  Month = 2,
  Quarter = 3,
  Year = 4,
  Custom = 5,
  FourWeek = 6
}
